// extracted by mini-css-extract-plugin
export default {"input":"CodeInput_input__yYRTr","error":"CodeInput_error__96c4h"};